import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d74b32e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container sw-work-navigation-container" }

import {
  withDefaults,
  computed,
  ref,
} from 'vue';
import SwGenreNavigation from '@/components/organisms/Navigations/SwGenreNavigation.vue';
import SwProcessNavigation from '@/components/organisms/Navigations/SwProcessNavigation.vue';
import { Forms, Genres } from '@/api/spotwrite';

interface Emits {
  (e: 'change:form', data: Forms | undefined): void;
  (e: 'change:genre', data: Genres | undefined): void;
}

interface Props {
  processes?: Forms[];
  genres?: Genres[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwWorkNavigation',
  props: {
    processes: { default: undefined },
    genres: { default: undefined }
  },
  emits: ["change:form", "change:genre"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change:form', data: Forms | undefined): void;
  (e: 'change:genre', data: Genres | undefined): void;
}), expose: any, slots: any, attrs: any }) {





/**
 * 工程の選択状態
 */
const currentForm = ref<Forms | undefined>(undefined);
const currentFormComputed = computed<Forms | undefined>({
  get: () => currentForm.value,
  set: (val) => {
    currentForm.value = val;
    emit('change:form', currentForm.value);
  },
});

/**
 * ジャンルの選択状態
 */
const currentGenre = ref<Genres | undefined>(undefined);
const currentGenreComputed = computed<Genres | undefined>({
  get: () => currentGenre.value,
  set: (val) => {
    currentGenre.value = val;
    emit('change:genre', currentGenre.value);
  },
});

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-work-navigation': true,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(classes))
    }, [
      _createVNode(SwProcessNavigation, {
        class: "sw-work-navigation--processes",
        modelValue: _unref(currentFormComputed),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentFormComputed) ? (currentFormComputed).value = $event : null)),
        items: __props.processes
      }, null, 8, ["modelValue", "items"]),
      _createVNode(SwGenreNavigation, {
        class: "sw-work-navigation--genres",
        modelValue: _unref(currentGenreComputed),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentGenreComputed) ? (currentGenreComputed).value = $event : null)),
        items: __props.genres
      }, null, 8, ["modelValue", "items"])
    ], 2)
  ]))
}
}

})